import { Middleware, UnknownAction } from '@reduxjs/toolkit';
import { pushAction } from './common';

export const reduxActionCaptureMiddleware: Middleware = () => (next) => (action) => {
  pushAction({
    type: (action as UnknownAction).type,
    payload: (action as UnknownAction).payload,
    timestamp: Date.now(),
  });

  return next(action);
};
